module.exports = __webpack_public_path__ + "img/sec_02.131140a5.jpg";